(function () {
  'use strict';

  var PROVINCE_CODE = 'speakout.province_code';
  var BYOP_CHOICE = 'speakout.byop_choice';
  var TAB_ACTIVE_CLASS = 'speakout-province-gate__tab--active';
  var OPTION_SELECTED_CLASS = 'speakout-province-gate__dropdown-option--selected';

  function SpeakOutProvinceGate(sectionEl) {
    this.section = sectionEl;
    this.select = sectionEl.querySelector('[data-province-change]');
    this.trigger = sectionEl.querySelector('[data-province-trigger]');
    this.display = sectionEl.querySelector('[data-province-display]');
    this.dropdownList = sectionEl.querySelector('[data-province-list]');
    this.dropdownOptions = sectionEl.querySelectorAll('[data-province-code]');
    this.toggleBtns = sectionEl.querySelectorAll('[data-phone-toggle-btn]');
    this._restoreState();
    this._bindEvents();
  }

  SpeakOutProvinceGate.prototype._updateProvinceDisplay = function (code) {
    if (!this.display) return;
    if (!code) {
      this.display.textContent = 'Select province';
      return;
    }
    var opt = this.select ? this.select.querySelector('option[value="' + code + '"]') : null;
    var name = opt ? opt.textContent.trim() : code;
    this.display.textContent = name;
    this._markSelectedOption(code);
  };

  SpeakOutProvinceGate.prototype._markSelectedOption = function (code) {
    this.dropdownOptions.forEach(function (li) {
      var selected = li.dataset.provinceCode === code;
      li.setAttribute('aria-selected', String(selected));
    });
  };

  SpeakOutProvinceGate.prototype._openDropdown = function () {
    if (!this.dropdownList) return;
    this.dropdownList.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  };

  SpeakOutProvinceGate.prototype._closeDropdown = function () {
    if (!this.dropdownList) return;
    this.dropdownList.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  };

  SpeakOutProvinceGate.prototype._restoreState = function () {
    var savedProvince = sessionStorage.getItem(PROVINCE_CODE);
    var savedChoice = sessionStorage.getItem(BYOP_CHOICE);

    if (savedProvince && this.select) {
      this.select.value = savedProvince;
      this._updateProvinceDisplay(savedProvince);
    }

    if (savedChoice) {
      this._setActiveToggle(savedChoice);
    }
  };

  SpeakOutProvinceGate.prototype._setActiveToggle = function (choice) {
    this.toggleBtns.forEach(function (btn) {
      var isActive = btn.dataset.choice === choice;
      btn.classList.toggle(TAB_ACTIVE_CLASS, isActive);
      btn.setAttribute('aria-pressed', String(isActive));
    });
  };

  SpeakOutProvinceGate.prototype._selectProvince = function (code) {
    if (this.select) {
      this.select.value = code;
      this.select.dispatchEvent(new Event('change'));
    }
    this._closeDropdown();
  };

  SpeakOutProvinceGate.prototype._bindEvents = function () {
    var self = this;

    if (this.select) {
      this.select.addEventListener('change', function () {
        var code = self.select.value;
        if (code) {
          sessionStorage.setItem(PROVINCE_CODE, code);
        } else {
          sessionStorage.removeItem(PROVINCE_CODE);
        }
        self._updateProvinceDisplay(code);
      });
    }

    if (this.trigger) {
      this.trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (self.dropdownList && !self.dropdownList.hidden) {
          self._closeDropdown();
        } else {
          self._openDropdown();
        }
      });
    }

    this.dropdownOptions.forEach(function (li) {
      li.addEventListener('click', function () {
        self._selectProvince(li.dataset.provinceCode);
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          self._selectProvince(li.dataset.provinceCode);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (self.dropdownList && !self.dropdownList.hidden) {
        if (!self.section.contains(e.target)) {
          self._closeDropdown();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.dropdownList && !self.dropdownList.hidden) {
        self._closeDropdown();
        if (self.trigger) self.trigger.focus();
      }
    });

    this.toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = btn.dataset.choice;
        sessionStorage.setItem(BYOP_CHOICE, choice);
        self._setActiveToggle(choice);
      });
    });
  };

  function init(sectionEl) {
    if (sectionEl._speakoutProvinceGate) return;
    sectionEl._speakoutProvinceGate = new SpeakOutProvinceGate(sectionEl);
  }

  document.querySelectorAll('[data-speakout-province-gate]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-speakout-province-gate]');
    if (el) init(el);
  });
})();
